export const API_BASE_URL = "https://api.etguesthome.com";
export const API_KEY =
  "GrQ2S9ItVastknLONLr2Apmcdj2VnFE9JIBRdv5xZVipWNsUpcGzQ0zROhDaHbI8ZsBKiYaMImVOph2TKHNXfv6pXetDmsWTSUFGjhq-Xkctw367mkUOSZ0xgVMQmU7s50dxFQ";
export const API_KEY2 =
  "Wm9z46p9Jg8gowO9kdbAyQEduWS8vVewESgbflS6LQEOA0RyWFEBm1J2Z6u48s5JW5f77QR7C9gSLnPChk7NCMO4L7QrwcLB9jU5fHAlX76WUr7IAwEjRn2I44y93-6Pfuoy_Q";

// export const API_BASE_URL = "https://dev.etguesthome.com";
// export const API_KEY =
//   "B_GqZpKEdCoZ844QtzlXG1Kc7eLJ8_QI2nZY8m8vTKgKvcnDBzVdVW--0awZzUSikbZfKGtt50_g-GOlC1wvQlbMVvOZszBEMBIDuJWJ9SGUJ__mjma6jOomaoaAdBrGlyKPWw";
